import React, { useEffect } from "react";
import { animateScroll } from "react-scroll";

import styles from "./index.module.css";
import { Question } from "@/components/Question";
import { Answer } from "@/components/Answer";
import { AskResponse, InteractionType } from "@/api";
import { useTranslation } from "react-i18next";
// import { Suggestions } from "@/components/Suggestions";
import AnswerBox from "@/components/Answer/AnswerBox";

import { useSelector } from "react-redux";
import { RootState } from "@/store";

interface MessagesProps {
    answers: [user: string, response: AskResponse][];
    selectedAnswer: number | null;
    activeAnalysisPanelTab?: string;
    useSuggestFollowupQuestions: boolean;
    lastQuestionRef: React.RefObject<any>;
    error?: Error | undefined;
    makeApiRequest: (query: string, type: InteractionType) => Promise<void>;
    makelikeAPIRequest: (like: boolean, iteration_id: string) => void;
}

const isAnswerNotEmpty = (a: [user: string, response: AskResponse]): boolean => a[1].answer !== "";

const Messages: React.FC<MessagesProps> = ({
    answers,
    selectedAnswer,
    activeAnalysisPanelTab,
    useSuggestFollowupQuestions,
    lastQuestionRef,
    error,
    makeApiRequest,
    makelikeAPIRequest
}) => {
    const isLoading = useSelector((state: RootState) => state.values.isLoading);
    const { t } = useTranslation();

    useEffect(() => {
        if (answers) {
            animateScroll.scrollToBottom({
                containerId: "messageContainer"
            });
        }
    }, [answers]);

    if (!lastQuestionRef.current) {
        return (
            <div className={styles.suggestions}>
                <div className={styles.chatEmptyState}>
                    <AnswerBox sanitizedAnswerHtml={t("chat.message")} isStreaming={false} showAvatar={true} />
                </div>
                <div className={styles.wrapperSuggestion}>
                    {/* <Suggestions
                        data={SuggestionsExample.map(suggestion => ({
                            ...suggestion,
                            text: t(suggestion.text),
                            value: t(suggestion.value)
                        }))}
                        onSuggestionClicked={example => makeApiRequest(example, InteractionType.chatExample)}
                    /> */}
                </div>
            </div>
        );
    }

    return (
        <div className={styles.chatMessageStream} id="messageContainer">
            {answers.filter(isAnswerNotEmpty).map((answer, index) => (
                <div key={index}>
                    <Question message={answer[0]} />
                    <Answer
                        key={index}
                        answer={answer[1]}
                        isSelected={selectedAnswer === index && activeAnalysisPanelTab !== undefined}
                        onSuggestionClicked={q => makeApiRequest(q, InteractionType.chatFollowUp)}
                        showFollowupQuestions={useSuggestFollowupQuestions}
                        likeCall={makelikeAPIRequest}
                    />
                </div>
            ))}
            {isLoading && (
                <>
                    <Question message={lastQuestionRef.current} />
                    <AnswerBox sanitizedAnswerHtml="" isStreaming={true} showAvatar={true} />
                </>
            )}
            {error && !isLoading && (
                <>
                    <Question message={lastQuestionRef.current} />

                    <AnswerBox
                        sanitizedAnswerHtml=""
                        isStreaming={true}
                        showAvatar={true}
                        error={error.toString()}
                        onRetry={() => makeApiRequest(lastQuestionRef.current, InteractionType.chatRetry)}
                    />

                    {/* <div className={styles.wrapperSuggestion}>
                        <Suggestions
                            data={SuggestionsExample.map(suggestion => ({
                                ...suggestion,
                                text: t(suggestion.text),
                                value: t(suggestion.value)
                            }))}
                            onSuggestionClicked={example => makeApiRequest(example, InteractionType.chatExample)}
                        />
                    </div> */}
                </>
            )}
        </div>
    );
};

export default Messages;
